export default __webpack_public_path__ + "static/media/photo-charte11.492ab7d2.png";